import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import cs from 'classnames';
// import './index.less'
import styles from './index.less';
const prefix = 'qyf';

const Eject = (props) => {
  const { isShow = false, children, className } = props;

  useEffect(() => {
    if (isShow) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isShow]);

  return (
    <>
      {isShow && (
        <div>
          <CSSTransition
            in={isShow}
            timeout={300}
            classNames="my"
            unmountOnExit
          >
            <div className={`${styles.qyfEjectMask}`}>
              <div className={`${styles.qyfEjectContent}`}>{children}</div>
            </div>
          </CSSTransition>
        </div>
      )}
    </>
  );
};

export default Eject;
